import request from '@/utils/request'

export function updateCfg(data) {
  return request({
    url: 'api/v1/func-preview-config/update',
    method: 'post',
    data: data
  })
}

export function getList(data) {
  return request({
    url: 'api/v1/func-preview-config/getList',
    method: 'post',
    data: data
  })
}

export function delFunc(data) {
  return request({
    url: 'api/v1/func-preview-config/delete',
    method: 'delete',
    data: data
  })
}
